import React from 'react';

import { useTranslations } from 'utils';
import { future } from 'utils/date/date';

const SubscriptionBreakdown = () => {
  const i18n = useTranslations();

  return (
    <div id="payer_information-description">
      <dl className="FlexGrid FlexGrid--fromXSmall-2">
        <div>
          <dt>{i18n.t('paymentInformationBreakdown.subscription.interval')}</dt>
          <dd data-hj-suppress data-testid="interval">
            {i18n.t('paymentInformationBreakdown.subscription.monthly')}
          </dd>
        </div>

        <div>
          <dt>
            {i18n.t('paymentInformationBreakdown.subscription.nextPaymentDate')}
          </dt>
          <dd data-hj-suppress data-testid="subscription-next-payment">
            {future(1, 'M', 'L')}
          </dd>
        </div>
      </dl>
    </div>
  );
};

export { SubscriptionBreakdown };
